module.exports = __webpack_public_path__ + "static/dashboard-iPad-81d48fa5ea2c81ed101b48302fc493cb.png";